import {
  AfterViewInit,
  Directive,
  ElementRef,
  input,
  model,
} from '@angular/core';
import { FormValueControl } from '@angular/forms/signals';
import { debounceTime, distinctUntilChanged, fromEvent } from 'rxjs';

@Directive({
  selector: '[lepiInput]',
})
export class InputDirective implements AfterViewInit, FormValueControl<string> {
  debounce = input<number>(0);
  value = model<string>('');

  constructor(private readonly elementRef: ElementRef<HTMLInputElement>) {}

  async ngAfterViewInit() {
    // type이 date일 때 작동하지 않음
    fromEvent(this.elementRef!.nativeElement, 'input')
      .pipe(debounceTime(this.debounce()), distinctUntilChanged())
      .subscribe((ev: Event) => {
        const inputElement = ev.target as HTMLInputElement;
        let inputValue = inputElement?.value;
        this.value.set(inputValue);
      });
  }
}
